<div class="content" [ngClass]="banner.type">
    <div class="message">
        <span *ngIf="!banner.html" [innerHTML]="banner.content"></span>
    </div>
    <button
        *ngIf="banner.isDismissable"
        (click)="closeBanner()"
        [attr.aria-label]="'common_close' | translate"
        type="button"
        class="is-dismissable goreact-btn btn-none">
        <span class="ficon-app-x"></span>
    </button>
</div>
